import { APEX_API_URL } from '@/constants';
import { IProduct } from '@/interfaces/product';
import { INextAuthSessionModel } from '@/interfaces/authentication';
import { IAddToWishlist, IWishlist } from '@/interfaces/wishlist';
import { getAxiosInstance } from '@/utils/axios-instance';

export const addToWishlist = async (item: IAddToWishlist): Promise<IProduct> => {
  const response = await getAxiosInstance().post(`${APEX_API_URL}/api/wishlist`, item);
  return response.data;
};

export const getWishlist = async (session?: INextAuthSessionModel | null): Promise<IWishlist> => {
  const response = await getAxiosInstance().get(`${APEX_API_URL}/api/wishlist`, {
    headers: {
      Authorization: 'Bearer ' + session?.accessToken,
    },
  });
  return response.data;
};
export const deleteFromWishlist = async (id: string): Promise<any> => {
  const body = {
    productId: id,
    //  wishlistItemId: id,
  };
  const response = await getAxiosInstance().delete(`${APEX_API_URL}/api/wishlist`, { data: body });
  return response.data;
};
